<template>
  <div class="modal nb-modal-mask" style="display:block; z-index: 1 !important;" @keyup.esc="closeModal">
    <Trap>
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document"
        style="width: 120vh!important; overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-body pt-3" style="height: 90vh!important; max-height: 100%; overflow-y: auto;">
            <div class="lbl mb-2" style="font-size: 20px">
              <strong>Fechamento do Caixa</strong>
            </div>
            <button @click="closeModal" class="close">
              <span>&times;</span>
            </button>
            <div class="main-content">
              <fechar-caixa :index="caixa" @closeform="handleRetorna" :modal="true"></fechar-caixa>
            </div>
          </div>
        </div>
      </div>
    </Trap>
  </div>
</template>

<script>
import BarList from "../components/bar-list";
import { apiORDS } from "../shared/api-functions";
import fecharCaixa from './varejo-fecharcaixa-form'

export default {
  components: {
    BarList,
    fecharCaixa
  },
  props: {
    params_pdv: {
      type: Object,
      default: () => ({ colors: {} })
    },
    caixa: null
  },
  data() {
    return {
      showForm: false,
      codvabertura: null,
      filter: "",
      monthQuery: "",
      textQuery: "",
      statusQuery: "",
      filtroStatus: {
        list: [
          { id: 0, label: "Todos" },
          { id: 1, label: "Em Aberto" },
          { id: 2, label: "Fechados" },
          { id: 3, label: "Conferidos" }
        ],
        index: 0
      },
      query: {
        codusuario: null,
        codequipe: null,
        text: null,
        after: null,
        before: null,
        codstatus: null
      },
      vaberturaList: [],
      isLoading: false,
      offset: false
    };
  },
  computed: {
    labelStatus() {
      return this.filtroStatus.list[this.filtroStatus.index].label;
    },
    headerStyle() {
      return {
        background: this.params_pdv.colors.bg_top_bottom || "#174b79"
      };
    },
    titleStyle() {
      return {
        color: this.params_pdv.colors.fc_top_bottom || "white"
      };
    }
  },
  methods: {
    // handleScroll(event) {
    //   const { scrollTop, scrollHeight, clientHeight } = event.target;
    //   if (scrollHeight - (scrollTop + clientHeight) < 50 && !this.isLoading) {
    //     this.loadMoreData();
    //   }
    // },
    // async loadMoreData() {
    //   if (this.isLoading) return;
    //   this.isLoading = true;
    //   this.offset = true;
    //   await this.loadData();
    //   this.isLoading = false;
    // },
    async loadData() {
      let param = {};
      param.query = "";

      if (this.filtroStatus.index) {
        param.query += `status=${this.filtroStatus.index}&`;
      }
      if (this.query.text) {
        param.query += `text=${this.query.text}&`;
      }
      if (this.query.after) {
        param.query += `after=${this.query.after}&`;
      }
      if (this.query.before) {
        param.query += `before=${this.query.before}&`;
      }
      if (this.offset) {
        param.query += `poffset=${this.vaberturaList.length}&`;
      }

      param.query = param.query.trim();
      if (param.query.endsWith("&")) {
        param.query = param.query.slice(0, -1);
      }

      const data = await apiORDS(
        this.$store.getters.urlOrds + "varejo/controlecaixa/list",
        param
      );
      if (data.items) {
        this.vaberturaList = this.offset
          ? [...this.vaberturaList, ...data.items]
          : data.items;
      }
    },
    handleShowForm(caixa) {
      this.codvabertura = caixa.codvabertura;
      this.showForm = true;
    },
    handleChangeFiltroStatus(index) {
      this.filtroStatus.index = index;
      this.loadData();
    },
    changeFiltroTexto(value) {
      this.query.text = value.toUpperCase();
      this.query.after = null;
      this.query.before = null;
      this.loadData();
    },
    changeFiltroMes(filter, startDate, endDate) {
      this.query.after = startDate;
      this.query.before = endDate;
      this.query.text = null;
      this.loadData();
    },
    closeModal() {
      this.$emit("close");
    }
  },
  created() {
    this.loadData();
    window.addEventListener("keyup", event => {
      if (event.key === "Escape") this.closeModal();
    });
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.closeModal);
  }
};
</script>

<style scoped>
.mainbox {
  overflow: visible;
}

.main-content {
  overflow-y: hidden;
}

.box {
  float: none;
}
</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-modal-caixa.vue